<img *ngIf="type == 'IMAGE'" [src]="url" [alt]="title" />
<video
  *ngIf="type == 'VIDEO'"
  [src]="url"
  controls
  autoplay
  preload="auto"
></video>
